import BaseComponent from "@js/components/base_component.jsx";
import classNames from "@js/helpers/class_names.js";
import { v4 as uuidv4 } from "uuid";

// This component provides a popup menu for entering one or more elements (such
// as a domain or campaign id).

class ListSelector extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      id: "list-selector-" + uuidv4(),
      query: props.query || "",
      modalOpen: false,
    };
  }

  componentWillUnmount() {
    document.removeEventListener("click", this._onRootClick);
  }

  componentDidMount() {
    document.addEventListener("click", this._onRootClick);
  }

  render() {
    return (
      <div
        id={ this.state.id }
        onClick={ this._toggleModal }
        className={ "daterange-selector" }
      >
        { this._renderModal() }
        <FaIcon name={ `${ this.props.icon } fa-lg indicator` } />
        &nbsp;&nbsp;
        <span className="prefix"> { this.props.label } </span>
        &nbsp;&nbsp;
        <span className="value">{ this._renderPreviewText() } </span>
        &nbsp;&nbsp;
        <FaIcon name="caret-down fa-lg" />
      </div>
    );
  }

  _renderPreviewText() {
    const originalQuery = this.props.query || "";
    const elements = originalQuery.split(/[,\s]+/g).filter(e => e !== "");

    if ( elements.length > 0 ) {
      if ( elements.length > 3) {
        return [elements[0], elements[1], elements[2], "..."].join(", ");
      } else {
        return elements.join(", ");
      }
    }

    return this.props.blankLabel;
  }

  _renderModal() {
    if ( !this.state.modalOpen ) return null;

    const style = {
      position: "absolute",
      top: this.state.modalTop,
      left: this.state.modalLeft,
      display: "inline-block",
      cursor: "default"
    };

    return (
      // if you anywhere on the screen, the modal is dismissed.
      // e.stopPropagation() here makes sure that clicking inside the
      // modal doesn't affect that call
      <div
        onClick={e => e.stopPropagation()}
        className="domain-filter-modal popover bottom in add-shadow"
        role="tooltip"
        style={style}
      >
        <div className="arrow" style={{ right: "5px", left: "auto" }} />
        <div className="popover-content">
          <textarea
            className="form-control"
            value={ this.state.query }
            onChange={ this._updateQuery }
            style={{ width: "246px", height: "128px" }}
          />
          {
            this.props.helpText &&
              <div className="row">
                <div className="col-sm-10 col-sm-offset-1">
                  <div style={{ textAlign: "center" }}>
                    { this.props.helpText }
                  </div>
                </div>
              </div>
          }
          <br />
          <div className="clearfix">
            <button
              className="pull-left btn btn-success btn-sm"
              onClick={ this._doSearch }
            >
              {I18n.t("buttons.filter")}
            </button>
            {this.state.query.length > 0 && (
              <button
                className="pull-right btn btn-default btn-sm diminished-button"
                onClick={ this._clearSearch }
              >
                {I18n.t("buttons.clear")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  _toggleModal() {
    if ( this.state.modalOpen ) {
      this.setState({
        modalOpen: false,
      });
      return;
    }

    var $selector = $(`#${ this.state.id }`);

    this.setState({
      modalOpen: true,
      modalTop: $selector.position().top + $selector.height() + 12,
      modalLeft: $selector.position().left + $selector.width() - 250,
    });
  }

  _hideModal() {
    this.setState({ modalOpen: false });
  }

  _updateQuery(e) {
    this.setState({
      query: e.target.value,
    });
  }

  _doSearch() {
    this.props.onChange(this.state.query);
  }

  _clearSearch() {
    this.setState({ query: "" }, () => {
      this._doSearch();
    });
  }

  _onRootClick(e) {
    var clickedOutsideOfModal = $(e.target).parents(`#${ this.state.id }`).length === 0;
    var clickedModalDiv       = e.target.id === this.state.id;

    if ( !clickedModalDiv && clickedOutsideOfModal && this.state.modalOpen ) {
      this.setState({ modalOpen: false });
    }
  }

}

export default ListSelector;
